const base = `${process.env.HOST}:${process.env.PORT}`
let get = "GET"
let post = "POST"
let patch = "PATCH"
let put = "PUT"
const ApiSetting = {
  errmessage: "网络错误",
  login: {url: '/api/auth/login/', method: post, name: "登陆接口"},
  getuser: {url: '/api/auth/user/', method: get, name: "获取账号信息"},
  getShortMsg: {url: '/api/auth/short_msg/', method: get, name: "获取短信验证码"},
  getUserC: {url: '/api/auth/user_C/', method: get, name: "获取C端账号信息"},
  loginout: {url: '/api/auth/logout/', method: post, name: "退出登陆"},
  speechreport: {url: "/api/voice/speech_evaluation_report/", method: post, name: "speechreport"},//获取用户默认教材和单元以及lesson
  listExastudent: {url: "/api/examination/publish_examination/list_student/", method: post, name: "listExastudent"},//获取试卷内容
  getexastate: {url: "/api/examination/publish_examination/{exaid}/get_state/", method: get, name: "getexastate"},//获取机考试卷状态
  getexaloading: {url: "/api/examination/publish_examination/{exaid}/loading/", method: get, name: "getexaloading"},//获取试卷内容
  update_: {url: "/api/examination/user_publish_examination/{userexaid}/update_/", method: post, name: "getexaloading"},//获取试卷内容
  saveExaCommit: {
    url: "/api/examination/user_publish_examination/{exaid}/commit/",
    method: post,
    name: "saveExaCommit"
  },//提交试卷数据
  getAudioData: {url: '/api/resources/amazon/', method: post, name: "getAudioData"},//获取音频
  commit: {url: '/api/examination/user_publish_examination/{exaid}/commit/', method: post, name: "commit"},//提交本地数据

}
export default ApiSetting



// WEBPACK FOOTER //
// ./src/api/index.js